import { render, staticRenderFns } from "./problemIndex.vue?vue&type=template&id=7c437ec6"
import script from "./problemIndex.vue?vue&type=script&lang=js"
export * from "./problemIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports